import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index';

import axios from 'axios';
import VueAxios from 'vue-axios';
import _axios from './utils/api';
import simpleUser from './utils/simpleUser';
import saasApi from '@/utils/saasApi';

import * as tool from '@/utils/tool';
import * as wallet from '@/utils/wallet';
// import * as pennonedu from "@/utils/pennonedu";
import * as filters from '@/filters/filters';
import * as Maths from '@/utils/Math';
import getApiConfig from './utils/configHook';

Object.keys(tool).forEach((item) => {
  Vue.prototype['$' + item] = tool[item];
});

Object.keys(wallet).forEach((item) => {
  Vue.prototype['$' + item] = wallet[item];
});

// Object.keys(pennonedu).forEach(item => {
//   Vue.prototype['$' + item] = pennonedu[item];
// });

Object.keys(filters).forEach((item) => {
  Vue.filter(item, filters[item]);
});

Object.keys(Maths).forEach((item) => {
  Vue.prototype['$Math_' + item] = Maths[item];
});

import './assets/reset.css';
import './assets/public.css';
import '../theme/index.css';
import ElementUI from 'element-ui';

/**
 * $cookie.set(keyName, value[, expireTimes[, path[, domain[, secure[, sameSite]]]]])
 */
const VueCookie = require('vue-cookie');

Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VueCookie);

Vue.prototype.$axios = _axios;
// ZHH:
Vue.prototype.$api = (method, data) => {
  return _axios(method, { ...data });
};

Vue.config.productionTip = false;

//引入nprogress
import NProgress from 'nprogress'; // 进度条
import './assets/nprogress.css'; //这个样式必须引入

NProgress.inc(0.2);
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false });

import { Message } from 'element-ui';
//定义一个新的Message方法，多传入一个offset参数
const $message = (options) => {
  return Message({
    ...options,
    offset: 80,
  });
};

//重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach((type) => {
  $message[type] = (options) => {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 80,
      };
    }
    options.type = type;
    return Message(options);
  };
});
//将$message挂载到this上
Vue.prototype.$message = $message;
Vue.prototype.$simpleUser = simpleUser;

import toast from '@air-cloud/vue-toast';
Vue.use(toast);

// * ZHH: 引入dayjs
import dayjs from 'dayjs';
Vue.prototype.dayjs = dayjs;

/**
 * 默认全局saas数据定义，在没有配saas的情况下，使用数据.默认走CPX逻辑，根据需求修改
 * 如果配置了saas，则不用考虑默认数据，直接走saas的逻辑
 * */
const getDomainInfo = async (config = null) => {
  if (config === null) {
    config = await getApiConfig();
  }

  let tmpProductCode = config.PRODUCT_CODE;
  let tmpPomainName = config.DO_MAIN_NAME;

  if (window.location.href.includes('aisudu.com')) {
    tmpProductCode = 'ASD';
    tmpPomainName = 'aisudu.com';
  } else if (window.location.href.includes('pennonedu.com')) {
    tmpPomainName = 'pennonedu.com';
  } else if (location.href.includes('pingcexue.com')) {
    tmpProductCode = 'CPX';
    tmpPomainName = 'pingcexue.com';
  }

  let globalDomainInfo = {
    name: '爱易佰',
    domainName: tmpPomainName,
    domainLogo: '/static/aie-logo.jpg',
    domainCopyright: 'Copyright © 2021 成都爱易佰网络科技有限公司 版权所有|蜀ICP备12029833号-2',
    address: '/static/favicon.ico',
    backgroundImg: '/static/BG@2x.png',
    webBoxAlign: 'center',
    productCode: tmpProductCode,
  };

  return globalDomainInfo;
};

let startApp = () => {
  // ZHH: 修改了获取配置文件的地址，主要是配合测试，方便改api
  getApiConfig().then(async (data) => {
    // 加载本地默认SaaS配置
    let globalDomainInfo = await getDomainInfo(data);

    /**
     * 初始化saas数据
     * 条件1：url不带pingcexue与aisudu
     * 条件2：
     *    本地环境下打开了SaaS模式 或
     *    生产模式
     * 同时满足两个条件，则初始化SaaS逻辑
     */
    if (
      !window.location.href.includes('pingcexue.com') &&
      !window.location.href.includes('aisudu.com') &&
      (data.IS_SAAS_MODE || process.env.NODE_ENV === 'production')
    ) {
      globalDomainInfo = await actionGlobalDomainInfo();
    }

    // 判断是否模拟线上环境
    if (process.env.NODE_ENV === 'development') {
      let onlineFlag = window.location.href.includes(globalDomainInfo.domainName);
      Vue.prototype.JXPT_API = onlineFlag ? data.BASE_JXPT : data.LOCAL_JXPT;
      Vue.prototype.PAY_API = onlineFlag ? data.BASE_PAY : data.LOCAL_PAY;
    } else {
      Vue.prototype.JXPT_API = data.BASE_JXPT;
      Vue.prototype.PAY_API = data.BASE_PAY;
    }

    window.hv = new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>',
      created() {},
      mounted() {
        //通过域名设置cookie
        const getDomain = () => {
          /**
           * 如果不是生产模式，则使用本地域名，否则使用全局域名
           */
          if (process.env.NODE_ENV !== 'production' || location.href.includes('192.168')) {
            return location.hostname;
          } else {
            if (location.href.includes(globalDomainInfo.domainName)) {
              return '.' + globalDomainInfo.domainName;
            } else {
              globalDomainInfo.domainName = location.hostname;
              return '.' + globalDomainInfo.domainName;
            }
          }
        };

        window.__domain__ = getDomain();

        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = globalDomainInfo.address;

        // 兼容以前的 开始
        /* 对未配置SaaS的域名，载入默认配置项 */
        var documentTitle = globalDomainInfo.name;
        if (globalDomainInfo.address == '/static/favicon.ico') {
          if (location.href.indexOf('9728.net.cn') !== -1) {
            link.href = '/static/akt-favicon.png';
            documentTitle = '爱可提';
          } else if (location.href.indexOf('jhtun.cn') !== -1) {
            link.href = '/static/jht-favicon.png';
            documentTitle = '江海豚';
          } else if (location.href.indexOf('haiweiyoujia.com') !== -1) {
            link.href = '/static/hwyj-favicon.png';
            documentTitle = '海薇优';
          } else if (location.href.indexOf('xheiben.com') !== -1) {
            link.href = '/static/xhb-favicon.png';
            documentTitle = '小黑本';
          } else if (location.href.indexOf('aishangfen.com') !== -1) {
            link.href = '/static/asf-favicon.png';
            documentTitle = '爱上分';
          } else if (location.href.indexOf('zhuangyuan345.com') !== -1) {
            link.href = '/static/zysx-favicon.png';
            documentTitle = '状元数学';
          } else if (location.href.indexOf('gaofenai.com') !== -1) {
            link.href = '/static/zysx-favicon.png';
            documentTitle = '高分壹号';
          }
        }
        // 兼容以前的 结束

        document.getElementsByTagName('head')[0].appendChild(link);
        document.title = documentTitle + '支付中心';
        this.$store.commit('saas/setGlobalDomainInfo', globalDomainInfo);
        // AIQA 智能答疑
        // "ASD" || // 艾速度
        //  "CPX" || // 评测学
        //  "SS" // 远程督导
      },
    });
  });
};

router.beforeEach((to, from, next) => {
  NProgress.start();
  simpleUser((data, roleStatus, roleName) => {
    // else if (roleName == 'student' && ['/renew', '/asdrenew'].indexOf(to.path) == -1) {
    //   //学生角色不可跳转 只能在支付页面
    //   Vue.prototype.$message({
    //     type: 'warning',
    //     message: '当前账号没有权限'
    //   });
    // }
    // console.log('SimpleUser Data:', data);
    if (to.path === '/login') {
      next();
    } else {
      if (data && data.sessionID && data.sessionID != '') {
        Vue.prototype.get_simpleUser = data;
        Vue.prototype.get_userId = data.userId;
        Vue.prototype.get_fullName = data.fullName;
        Vue.prototype.get_sessionId = data.sessionID;
        // if (to.path.includes('/back/') && (data.paymentManagerType === 0 || data.paymentManagerType === 1 || data.userId === "123456")) {
        if (to.path.includes('/back/')) {
          next();
        } else if (roleStatus.roleFlag) {
          //# 管理员
          if (to.path === '/manage') {
            next();
          } else if (to.meta.adminRole && to.meta.adminRole.includes(data.paymentManagerType)) {
            next();
          } else if (to.meta.adminRole && !to.meta.adminRole.includes(data.paymentManagerType)) {
            if (data.paymentManagerType === -1) {
              next({ path: '/login' });
            } else if (data.paymentManagerType === 0 || data.paymentManagerType === 1) {
              next();
            } else if (data.paymentManagerType === 2) {
              next({ path: '/manage/product' });
            } else if (data.paymentManagerType === 3) {
              next({ path: '/manage/order/review' });
            } else if (data.paymentManagerType === 4) {
              next({ path: '/manage/order/application' });
            }
          } else {
            next({ path: '/manage' });
          }
        } else {
          //# 代理商
          if (to.path.includes('/manage') || to.path.includes('/back/')) {
            next({ path: '/wallet/details' });
          } else {
            next();
          }
        }
      } else {
        delete Vue.prototype.get_simpleUser;
        delete Vue.prototype.get_userId;
        delete Vue.prototype.get_fullName;
        delete Vue.prototype.get_sessionId;
        Vue.prototype.$clearAllCookie();
        next({ path: '/login' });
      }
    }
  });
});

router.afterEach(() => {
  NProgress.done();
});

startApp();

/**
 * @description 获取全局域名信息
 * @returns {Promise<{name: string, domainName: string, domainLogo: string, domainCopyright: string, address: string, backgroundImg: string, productCode: string, webBoxAlign: "center" | "flex-start" | "flex-end"}>}
 */
function actionGlobalDomainInfo() {
  return new Promise(async (resolve, reject) => {
    var index = location.hostname.indexOf('.');
    var identifier = location.hostname.substring(index + 1);
    // 判断域名是否是纯IP4地址
    const pattern =
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    if (location.hostname.includes('localhost') || pattern.test(location.hostname)) {
      // 读配置文件 写死的110.248，如果想加载配置项，可以将ip改成 location.hostname
      // 获取配置 灵活使用则访问10086，写死可以直接配置config.json，生产模式不会进入到这里
      const configJson = await getApiConfig();
      console.log('Local domain:', configJson.DO_MAIN_NAME);

      identifier = configJson.DO_MAIN_NAME; // 根据本地需求修改
    }

    // 生产环境下，根据域名获取全局域名信息
    var params = {
      identifier: identifier, // www.akt.com
    };

    saasApi
      .get('/open/getProduct', params)
      .then(async ({ data: res }) => {
        let dataList = res.data ? res.data : null;
        let globalDomainInfo = {};
        if (dataList) {
          globalDomainInfo = {
            name: dataList.name,
            domainName: dataList.loginPageCustomDTO.identifier,
            domainLogo: dataList.loginPageCustomDTO.logo,
            domainCopyright: dataList.loginPageCustomDTO.copyrightInfo,
            address: dataList.loginPageCustomDTO.icon,
            backgroundImg: dataList.loginPageCustomDTO.backgroundImg,
            productCode: dataList.loginPageCustomDTO.productCode,
            webBoxAlign: changeBoxAlign(dataList.loginPageCustomDTO.loginBoxAlign),
          };
        } else {
          console.error('获取域名信息失败：SaaS中没有产品信息', res);
        }
        resolve(globalDomainInfo);
      })
      .catch((err) => {
        console.error('获取域名信息失败：SaaS中没有产品信息', err);
        reject(err);
      });
  });
}
/**
 *
 * @description 首页登录框版式切换
 */
function changeBoxAlign(val) {
  if (val === 0) {
    return 'flex-start';
  } else if (val === 1) {
    return 'center';
  } else {
    return 'flex-end';
  }
}



// WEBPACK FOOTER //
// ./src/main.js